<template>
    <div>
        <b-row class="justify-content-md-center">
          <b-col md="3">
            <span class="pr-2 text-uppercase" style="vertical-align: middle;">Schreib mir auf </span>
            <Network/>
          </b-col>
          <b-col md="3">
            <span class="pr-2  text-uppercase" style="vertical-align: middle;"> 
              Soziale Projekte
            </span>
            <span>
              <a href="https://www.radzelten.de" target="_blank"><img src="/img/radzelten_logo.png" height="35px"></a>
              |
              <a href="https://www.rt210.de" target="_blank"><img src="/img/rt_logo.png" height="40px"></a>
            </span>
          </b-col>
        </b-row>
    </div>
</template>

<script>
import Network from '@/components/Network.vue'
export default {
  name: 'Socialfooter',
  components:{
    Network
  }
}
</script>